import styled from "styled-components";
import { DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";

export const StyledDialogTitle = styled(DialogTitle)`
  & .MuiTypography-root {
    font-size: 18px;
    font-weight: 600;
    color: #424242;
  }
  padding: 24px 24px 16px;
`;

export const StyledDialogContent = styled(DialogContent)`
  padding: 0 24px 24px !important;
`;

export const StyledDialogActions = styled(DialogActions)`
  padding: 0 24px 24px !important;
  gap: 12px;
  justify-content: flex-end;
  display: flex;
  flex-wrap: wrap;
`;

export const CancelButton = styled(Button)`
  && {
    color: #1976D2;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 24px;
  }
`;

export const ConfirmButton = styled(Button)`
  && {
    background-color: #1976D2;
    color: #fff;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 36px;
    box-shadow: none;
    &:hover {
      background-color: #1565c0;
    }
  }
`;

export const StyledTypography = styled(Typography)`
  font-size: 14px;
  color: #424242;
  line-height: 1.6;
`;
